/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicineItemDto
 */
export interface MedicineItemDto {
    /**
     * Medicine ID
     * @type {string}
     * @memberof MedicineItemDto
     */
    medicineId: string;
    /**
     * SIG (Instruction) - Dose/Unit/Route/Frequency/Direction/Duration
     * @type {string}
     * @memberof MedicineItemDto
     */
    sig: string;
    /**
     * Dispense quantity (must be greater than 0)
     * @type {number}
     * @memberof MedicineItemDto
     */
    dispense: number;
    /**
     * Number of refills allowed (can be 0)
     * @type {number}
     * @memberof MedicineItemDto
     */
    refill: number;
}

/**
 * Check if a given object implements the MedicineItemDto interface.
 */
export function instanceOfMedicineItemDto(value: object): value is MedicineItemDto {
    if (!('medicineId' in value) || value['medicineId'] === undefined) return false;
    if (!('sig' in value) || value['sig'] === undefined) return false;
    if (!('dispense' in value) || value['dispense'] === undefined) return false;
    if (!('refill' in value) || value['refill'] === undefined) return false;
    return true;
}

export function MedicineItemDtoFromJSON(json: any): MedicineItemDto {
    return MedicineItemDtoFromJSONTyped(json, false);
}

export function MedicineItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicineItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'medicineId': json['medicineId'],
        'sig': json['sig'],
        'dispense': json['dispense'],
        'refill': json['refill'],
    };
}

export function MedicineItemDtoToJSON(json: any): MedicineItemDto {
    return MedicineItemDtoToJSONTyped(json, false);
}

export function MedicineItemDtoToJSONTyped(value?: MedicineItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicineId': value['medicineId'],
        'sig': value['sig'],
        'dispense': value['dispense'],
        'refill': value['refill'],
    };
}

